module.exports = __webpack_public_path__ + "img/html5.c27de52a.svg";